import {Users} from '../users'
import {MessageBox} from '../../../components/message-box'

export const browserInitUsers = () => {
  Users.init(MessageBox.show)
}
